import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EmailSettingsDataService {
	GMAIL_URL = '/protected/rest/settings/gmail';
	SMTP_URL = '/protected/rest/settings/email/smtp';

	constructor(private http: HttpClient) {}

	activatePromoSubscription(isAccepted: boolean): Observable<any> {
		const url = `/api/user/settings/promosubscription/${isAccepted}`;
		return this.http.put(url, {});
	}

	activateEmailNotification(isAccepted: boolean): Observable<any> {
		const url = `/protected/rest/company/notification/save/${isAccepted}`;
		return this.http.post(url, {});
	}

	getEmailSettings(): Observable<any> {
		const url = '/protected/rest/settings/company/get/emailsettings';
		const headers = new HttpHeaders().set(
			'Content-Type',
			'application/x-www-form-urlencoded'
		);
		return this.http.get(url, { headers });
	}

	saveEmailSignature(signature): Observable<any> {
		const url = '/protected/rest/settings/email/signature';
		return this.http.post(url, { signature });
	}

	saveSnServerSettings(settings): Observable<any> {
		const url = '/protected/rest/settings/email/default';
		return this.http.post(url, settings);
	}

	connectGmailServer(): Observable<any> {
		return this.http.get(this.GMAIL_URL);
	}

	saveGmailConnection(code: string): Observable<any> {
		return this.http.post(this.GMAIL_URL, { code });
	}

	disconnectGmailServer(): Observable<any> {
		return this.http.delete(this.GMAIL_URL);
	}

	saveSMTPServerSettings(settings): Observable<any> {
		return this.http.post(this.SMTP_URL, settings);
	}

	disconnectSMTPServer(): Observable<any> {
		return this.http.delete(this.SMTP_URL);
	}

	saveEmailTemplate(emailTemplate): Observable<any> {
		const url = '/protected/rest/settings/email_template/create';
		return this.http.post(url, emailTemplate);
	}

	updateEmailTemplate(emailTemplate): Observable<any> {
		const url = '/protected/rest/email_template/validate';
		return this.http.post(url, emailTemplate);
	}

	confirmEditEmailTemplate(emailTemplate): Observable<any> {
		const url = '/protected/rest/settings/email_template/update';
		return this.http.post(url, emailTemplate);
	}

	deleteEmailTemplate(emailTemplate): Observable<any> {
		const url = '/protected/rest/settings/email_template/delete';
		return this.http.post(url, emailTemplate);
	}

	getEmailTemplatesOnPage(data): Observable<any> {
		const {
			perPage,
			page,
			pageOrder: { predicate, reverse }
		} = data;
		let params = new HttpParams();
		params = params.append('perPage', perPage);
		params = params.append('page', page);
		params = params.append('predicate', predicate);
		params = params.append('reverse', reverse);
		const url = '/protected/rest/settings/email_template/get_all';
		return this.http.get(url, { params });
	}

	saveImage(dataToSave) {
		const url = '/protected/rest/signature/image/save';

		return this.http.post(url, dataToSave);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/settings/email-settings.data.service.ts